"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListPaymentCell = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const dateTimeFormat_1 = require("../../../../utils/dateTimeFormat");
const getPaymentIcon_1 = require("../../../../utils/getPaymentIcon");
const roundMoney_1 = require("../../../../utils/roundMoney");
const Icon_1 = require("../../../Icon");
const MultiLanguage_1 = require("../../../MultiLanguage");
const Tooltip_1 = require("../../../Tooltip");
require("./index.scss");
const className = 'list-payment-cell';
const ListPaymentCell = (props) => {
    var _a;
    const { total, totalPaid, modificators, payments } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const localizePayment = (payment) => {
        const datetime = (0, moment_1.default)(payment.createdAt, dateTimeFormat_1.DATETIME_OUTPUT_FORMAT).format(dateTimeFormat_1.DATETIME_FORMAT);
        const tooltip = `${payment.amount} CHF was paid by ${(0, MultiLanguage_1.fMultilanguage)(payment.type.name, locale)} on ${datetime}`;
        const icon = (0, getPaymentIcon_1.getPaymentIcon)(payment.type.code);
        return { tooltip, icon };
    };
    const totalPaidText = (0, roundMoney_1.localizeMoney)(totalPaid, locale, 'Reservation/List/Payment/totalPaid');
    const totalText = (0, roundMoney_1.localizeMoney)(total, locale, 'Reservation/List/Cell/total');
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__icons` }, (_a = payments === null || payments === void 0 ? void 0 : payments.map(localizePayment)) === null || _a === void 0 ? void 0 : _a.map((payment, idx) => (react_1.default.createElement(Tooltip_1.Tooltip, { key: idx, text: payment.tooltip, modificators: 'white' },
            react_1.default.createElement(Icon_1.Icon, { name: payment.icon }))))),
        react_1.default.createElement("div", { className: `${className}__debt` }, `${totalPaidText} / ${totalText} CHF`)));
};
exports.ListPaymentCell = ListPaymentCell;
//# sourceMappingURL=index.js.map